import { api } from "./httpClient";

export const settingsService = {
  getSettings() {
    return api("/settings");
  },
  saveSettings(payload) {
    return api("/settings", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },
  getPermissions() {
    return api("/permissions");
  },
  savePermissions(payload) {
    return api("/permissions", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },
};
